import { render } from "./underNoticePeriodNumbers.vue?vue&type=template&id=04ba9b46&scoped=true"
import script from "./underNoticePeriodNumbers.vue?vue&type=script&lang=js"
export * from "./underNoticePeriodNumbers.vue?vue&type=script&lang=js"

import "./underNoticePeriodNumbers.vue?vue&type=style&index=0&id=04ba9b46&scoped=true&lang=scss"
import "./underNoticePeriodNumbers.vue?vue&type=style&index=1&id=04ba9b46&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ba9b46"]])

export default __exports__